import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutProspectTypeList extends Layout {
    layoutheaderSearchProspectTypes: LayoutHeader;
    sourceProspectType: DataSource;
    tableTypes: Table;
}
